import React from 'react';
import { toast } from 'react-toastify';

import { sendSubsCsv } from 'api';
import BaseModal from 'components/modals/BaseModal';
import UserSubsToCsvForm from './UserSubsToCsvForm';
import Spinner from 'components/Spinner';
import { SubmissionError } from 'redux-form';

import styles from './styles.module.scss';

class UserSubsToCsv extends React.Component {
  state = {
    isOpen: false,
    success: false,
    loading: false,
  };

  componentDidMount() {
    this.setUserEmail();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loggedInUser !== this.props.loggedInUser) {
      this.setUserEmail();
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  setUserEmail = () => {
    const { loggedInUser } = this.props;
    this.setState({ email: loggedInUser.email });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  handleChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  };

  requestCsv = (values) => {
    const { userId } = this.props;

    this.setState({
      loading: true,
    });

    let data = {
      to_email: values.email,
    };
    if (values?.carriers?.length && !values.carriers.includes('any')) {
      data.carriers = values.carriers;
    }
    if (values?.statuses?.length && !values.statuses.includes('any')) {
      data.statuses = values.statuses;
    }

    return sendSubsCsv(userId, data)
      .then(() => {
        this.closeModal();
        toast.success('CSV report sent');
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        throw new SubmissionError(messages);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const { isOpen, loading } = this.state;
    return (
      <div className="mar-t">
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.openModal}
          disabled={loading}
        >
          {loading ? 'Generating csv...' : 'Download subs as csv'}
        </button>
        <BaseModal
          isOpen={isOpen}
          title="Generate CSV"
          onClose={this.closeModal}
          className={styles.modal}
          confirmBtnText=""
          cancelBtnText=""
        >
          <UserSubsToCsvForm onSubmit={this.requestCsv} />
          <Spinner showLoader={loading} />
        </BaseModal>
      </div>
    );
  }
}

export default UserSubsToCsv;
